import type {ModalDialogService} from 'shared/modal-dialogs';
import type {Fond} from 'src/typings';
import type {FieldsDefinitionsDataService} from 'src/features/record-editation/field7-and-field8-editors/fields-definitions-data.service';
import type {
    Field8EditorModalModel
} from 'src/features/record-editation/field7-and-field8-editors/field8-editor-modal/types';

export class Field8ValueEditorService {
    public static serviceName = 'field8ValueEditorService';


    /*@ngInject*/
    constructor(private modalDialogService: ModalDialogService, private fieldsDefinitionsDataService: FieldsDefinitionsDataService) {
    }

    public async editModelFunction(model: string, editParams: Field8EditorAdditionalOptions): Promise<string> {
        const definitions = await this.fieldsDefinitionsDataService.getField008Definitions();

        const modalModel: Field8EditorModalModel = {value: model, fond: editParams.fond, definitions};
        return this.modalDialogService.openModalWindowAndGetPayload('field8Editor', modalModel);
    }
}

interface Field8EditorAdditionalOptions {
    fond: Fond;
}
